import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnBlockValue,
  returnUserContent,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

const HeaderBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div>
      {/* example of returning value - content */}
      <div
        style={{
          color: returnBlockValue(
            'text_color',
            'design',
            opBlocks[block],
            design
          ),
        }}
        className="font-bold text-2xl mt-6 mb-4 text-center"
      >
        {returnBlockValue('header_text', 'content', opBlocks[block], content)}
      </div>
    </div>
  )
}

export default HeaderBlock
